import api from './api';

export interface TrainingRecord {
  id: string;
  userId: string;
  employeeId?: string;
  title: string;
  description?: string;
  provider?: string;
  trainingDate: string;
  completionDate?: string;
  cost?: number;
  currency: string;
  status: 'planned' | 'in_progress' | 'completed' | 'cancelled';
  certificateUrl?: string;
  notes?: string;
  reminderDaysBefore?: number;
  reminderSent?: boolean;
  reminderSentAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateTrainingData {
  title: string;
  description?: string;
  provider?: string;
  trainingDate: string;
  completionDate?: string;
  cost?: number;
  currency?: string;
  status?: 'planned' | 'in_progress' | 'completed' | 'cancelled';
  certificateUrl?: string;
  notes?: string;
  employeeId?: string;
  reminderDaysBefore?: number;
  createExpense?: boolean;
}

export interface UpdateTrainingData {
  title?: string;
  description?: string;
  provider?: string;
  trainingDate?: string;
  completionDate?: string;
  cost?: number;
  currency?: string;
  status?: 'planned' | 'in_progress' | 'completed' | 'cancelled';
  certificateUrl?: string;
  notes?: string;
  employeeId?: string;
  reminderDaysBefore?: number;
}

export interface TrainingFilters {
  status?: 'planned' | 'in_progress' | 'completed' | 'cancelled';
  startDate?: string;
  endDate?: string;
}

export const trainingApi = {
  getAll: async (filters?: TrainingFilters): Promise<TrainingRecord[]> => {
    const params = new URLSearchParams();
    if (filters?.status) params.append('status', filters.status);
    if (filters?.startDate) params.append('startDate', filters.startDate);
    if (filters?.endDate) params.append('endDate', filters.endDate);

    const queryString = params.toString();
    const url = `/training${queryString ? `?${queryString}` : ''}`;
    const response = await api.get(url);
    return response.data.data;
  },

  getById: async (id: string): Promise<TrainingRecord> => {
    const response = await api.get(`/training/${id}`);
    return response.data.data;
  },

  create: async (data: CreateTrainingData): Promise<TrainingRecord> => {
    const response = await api.post('/training', data);
    return response.data.data;
  },

  update: async (id: string, data: UpdateTrainingData): Promise<TrainingRecord> => {
    const response = await api.put(`/training/${id}`, data);
    return response.data.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/training/${id}`);
  },
};
